import React from 'react';
import styles from './Payyitme.module.css';
import useScrollReveal from './hooks/useScrollReveal';
import Header from './Section/Header';
import HowItWorks from './Section/HowItWorks';
import UseCases from './Section/UseCases';
import FeatureBlocks from './Section/FeatureBlocks';
import Faq from './Section/Faq';
import CallToAction from './Section/CallToAction';

const Payyitme = () => {
  useScrollReveal('[data-sr]');

  return (
    <div className={styles.page}>
      <Header />
      <HowItWorks />
      <UseCases />
      <FeatureBlocks />
      <Faq />
      <CallToAction />
    </div>
  );
};

export default Payyitme;
